import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';


const CompanyBubble = ({ company, maxRevenue }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const bubbleRef = useRef(null);

  // Calculate relative size
  const minSize = 24;
  const maxSize = 52;

  const scale = Math.sqrt(company.revenue) / Math.sqrt(maxRevenue || 1);
  const size = Math.max(minSize, Math.min(maxSize, minSize + (scale * (maxSize - minSize))));

  
  const handleDragStart = (e) => {
    // Hide tooltip immediately on drag
    setShowTooltip(false);
    e.dataTransfer.setData('companyId', company.id);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleMouseEnter = () => {
    if (bubbleRef.current) {
      const rect = bubbleRef.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.top, // Top of the bubble
        left: rect.left + (rect.width / 2) // Center of the bubble
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const formatRevenue = (val) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(val);
  };

  // Map color to CSS Class
  const getColorClass = (color) => {
    switch (color) {
      case 'red': return 'bubble-red';
      case 'green': return 'bubble-green';
      case 'blue': return 'bubble-blue';
      case 'yellow': return 'bubble-yellow';
      case 'orange': return 'bubble-orange';
      case 'teal': return 'bubble-teal';
      default: return 'bubble-blue';
    }
  };

  const colorClass = getColorClass(company.color || 'blue');
  const shortName = company.name.substring(0, 3).toUpperCase();
  const fontSize = Math.max(9, size * 0.35);

  return (
    <>
      <div
        ref={bubbleRef}
        draggable
        onDragStart={handleDragStart}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`company-bubble ${colorClass}`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      >
        {/* 3D Ball Effect */}
        <div className="bubble-inner">
          {/* Specular Highlight */}
          <div className="bubble-highlight"></div>
        </div>

        {/* Short Name Label */}
        <span
          className="bubble-label"
          style={{ fontSize: `${fontSize}px`, lineHeight: 1 }}
        >
          {shortName}
        </span>
      </div>

      {/* Portal Tooltip - Renders at body level to avoid clipping */}
      {showTooltip && createPortal(
        <div
          className="bubble-tooltip-portal"
          style={{
            top: `${tooltipPos.top}px`,
            left: `${tooltipPos.left}px`
          }}
        >
          <p className="tooltip-name">{company.name}</p>
          <p className="tooltip-revenue">{formatRevenue(company.revenue)}</p>
          <div className="tooltip-arrow"></div>
        </div>,
        document.body
      )}
    </>
  );
};

export default CompanyBubble;